import { jsxs as S, jsx as c } from "@emotion/react/jsx-runtime";
import { Button as a } from "@partoohub/ui";
import { useBusinessModalContext as T } from "../../../BusinessModalContext.js";
import { useCountData as x } from "../../../hooks/useCountData.js";
import { useGetConfirmText as _ } from "./hooks/useGetConfirmText.js";
import { convertPreFiltersToFilters as k } from "../../../helpers/normalizr.js";
import { StickyFooter as y } from "../../StickyFooter/StickyFooter.styled.js";
import { selectAll as v, apply as w } from "../../../reducer/businessModal.actions.js";
import { SelectionType as A } from "../../../reducer/businessModal.types.js";
const G = () => {
  const {
    dispatch: e,
    filters: m,
    preFilters: t,
    setFilters: p,
    setOpen: f,
    translations: o,
    resetState: u
  } = T(), d = k(m, t), {
    hasSelectedBusinesses: s,
    hasUnselectedBusinesses: r
  } = x(), h = _(), n = t?.selection?.type !== A.UNSET, i = s || r || n, B = s || r || n, l = {
    size: "large",
    full: !0
  }, C = () => i ? u() : e(v()), F = () => {
    p(d), e(w()), f(!1);
  };
  return /* @__PURE__ */ S(y, { children: [
    /* @__PURE__ */ c(a, { dataTrackId: "business_modal_footer_save", appearance: "outlined", variant: "secondary", ...l, onClick: C, children: i ? o.reset : o.selectAll }),
    B && /* @__PURE__ */ c(a, { dataTrackId: "business_modal_footer_cancel", ...l, onClick: F, children: h })
  ] });
};
export {
  G as Footer
};
